import React            from 'react'
import * as PlugIns     from './plug-ins'
import {CKEditor}       from 'ckeditor4-react';
import Toolbar          from './toolbar'

export class Editor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fromClient: false
        };
    }

    componentDidMount() {
        this.setState({ 
            fromClient: true 
        });
    }

    getToolbars() {
        const p       = this.props;
        let toolbar = Toolbar;

        return toolbar;
    }

    getPlugIns() {
        const p = this.props;
        return p.plugIns && p.plugIns.join(',') || ''
    }
    
    render() {
        const p               = this.props;
        let toolbar         = this.getToolbars();
        let extraPlugins    = this.getPlugIns();
        return(
            this.state.fromClient 
            &&  <CKEditor  
                    initData        = { p && p.data && p.data }
                    data            = { p.data || '' }
                    onChange        = {( event ) => {
                        const data = event.editor.getData();
                        p.edit(data);
                    }}
                    onBeforeLoad    = { CKEDITOR => {
                        try {
                            if(p.plugIns) {
                                p.plugIns.map(plugIn => {
                                    if(PlugIns.default[plugIn]) {
                                        PlugIns.default[plugIn](CKEDITOR)
                                    }
                                })
                            }
                        } catch(err) {
                            return
                        }
                    }}
                    config          = {{
                        extraPlugins,
                        toolbar
                    }}
                />
            ||  null
        )
    }
}

export default Editor